export default [
  {
    path: '/marketing/live-room',
    name: 'coupon',
    component: () => import('@/pages/marketing/coupon/liveRoom'),
    meta: {
      spm: 2276,
    },
  },
  {
    path: '/marketing/live-room-coupon',
    name: 'couponiveRoom',
    component: () => import('@/pages/marketing/coupon/liveRoomCoupon'),
    meta: {
      spm: 2277,
    },
  },
];
